//#region Libraries
import styled from "styled-components";
//#endregion

export const ListOfCrossings = styled.ul`
    max-height: 185px;
    overflow-y: auto;
    padding-right: 10px;
`;